<div class="pag-container">

  <app-kv-breadcrumb [arrayBreadcrumbs]="breadcrumbs"></app-kv-breadcrumb>


  <form [formGroup]="dateRangeForm">
    <div class="ui-g-12">

      <div class="ui-g-6" style="margin-top: 20px;">
        <div class="ui-g-8 d-flex align-items-center">
          <span class="title"></span>
        </div>
        <div class="ui-g-4 d-flex align-items-center">
          <span class="title-span">{{ 'common.selectInterval' | translate }}</span>
        </div>
      </div>

      <div class="ui-g-3">
        <span class="date-range">{{ 'common.from' | translate }}</span>
        <br>
        <app-kv-calendar #dateStartField [inputName]="'startDate'" [formData]="dateRangeForm" [startDateSelector]="true"
          [endDateInputName]="'endDate'" [endDateCalendar]="dateEndField"></app-kv-calendar>
      </div>

      <div class="ui-g-3">
        <span class="date-range">{{ 'common.to' | translate }}</span>
        <br>
        <app-kv-calendar #dateEndField [inputName]="'endDate'" [formData]="dateRangeForm" [endDateSelector]="true"
          [startDateInputName]="'startDate'" [startDateCalendar]="dateStartField"></app-kv-calendar>
      </div>
    </div>
  </form>

  <div class="ui-g-12">
    <app-campaign-3-kontable #eventListTable id="eventListTable" [columns]="[
        {field: 'id', title: '#', filterType: noFilter, sortable: false},
        {field: 'tsInsert', title: 'audit.date', filterType: noFilter, bodyTemplate: startDateTemplate },
        {field: 'eventType', title: 'audit.eventTipology' },
        {field: 'eventTable', title: 'audit.eventTable' },
        {field: 'flgDeploy', title: 'audit.stateStatus', bodyTemplate: stateFilter, filterType: selectFilter, filterOptions: { values: statusList }}
      ]" [service]="eventsService" [paginationType]="paginationType" [showRecoverButton]="false"
      [showInfoButton]="false" [showAddButton]="false" [showDeleteButton]="false" [showDetailsButton]="false"
      [showEditButton]="false" [additionalRowCommands]="actions" [showGlobalFilter]="true"
      [filterStartDate]="dateRangeForm.get('startDate').value" [filterEndDate]="dateRangeForm.get('endDate').value"
      (onClearFilters)="clearDateFilters()" [fetchActionListAsap]="true" [filterBySingleColumn]="false"
      [expandTable]="false" [subjectToLoad]="pageSubject" [additionalRowCommands]="actions">

      <ng-template #stateFilter let-col>
        <p-dropdown [options]="statusList" [style]="{'width':'100%'}"
          (onChange)="changeStateFilter(col.field, $event.value)"
          [(ngModel)]="eventListTable.filter.search[col.field]"></p-dropdown>
      </ng-template>

      <ng-template #startDateTemplate data-testid="startDateTemplate" let-row>
        <span>{{ row.ts_ins | date:'dd/MM/yyyy' }}</span>
      </ng-template>
      <ng-template #stateFilter data-testid="stateFilter" let-row>
        <span *ngIf="row.flg_dpl === '0'">
          {{'audit.eventElStarted' | translate}}
        </span>
        <span *ngIf="row.flg_dpl === '1'">
          {{'audit.eventElOk' | translate}}
        </span>
        <span *ngIf="row.flg_dpl === '9'">
          {{'audit.eventElKo' | translate}}
        </span>
      </ng-template>
      <ng-template #actions let-row>

        <div class="detail-btn-container">
          <button class="btn-details" (click)="onOpenInfoAction(row)">
            <i class="pi pi-calendar icon-size"></i>
          </button>
        </div>

      </ng-template>
    </app-campaign-3-kontable>
  </div>

  <div *ngIf="showPopupInfoInsideTable">
    <p-dialog header="{{ 'audit.eventDetail' | translate }}" [(visible)]="showPopupInfoInsideTable" [modal]="true"
      [style]="{width: '60vw', height: '90vh'}" [draggable]="false" [resizable]="false" (onHide)="onClosePopupInfo()">
      <div style="max-height: 75vh; overflow: auto;">
        <pre>{{selectedEventContent | json}}</pre>
      </div>
    </p-dialog>
  </div>

</div>


// WEBPACK FOOTER //
// ./src/app/views/audit/events/events.component.html